import React, { useEffect } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Scene3D from '../components/Scene3D';
import OrientationCube from '../components/OrientationCube';
import BottomToolbar from '../components/BottomToolbar';
import ScaleIndicator from '../components/ScaleIndicator';
import TabsBar from '../components/TabsBar';
import useEditorStore from '../store/useEditorStore';

export default function Editor() {
  const showNotification = useEditorStore((s) => s.showNotification);
  const notification = useEditorStore((s) => s.notification);
  const segments = useEditorStore((s) => s.segments);
  const sidebarOpen = useEditorStore((s) => s.sidebarOpen);
  const setSidebarOpen = useEditorStore((s) => s.setSidebarOpen);
  const partsCount = segments.length * 3;

  useEffect(() => {
    const t = setTimeout(() => {
      showNotification(`${partsCount} pièce(s) générée(s) avec succès.`);
    }, 800);
    return () => clearTimeout(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`editor-shell ${sidebarOpen ? 'sidebar-open' : ''}`}>
      <Header />
      <Sidebar />
      {sidebarOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setSidebarOpen(false)}
          data-testid="sidebar-backdrop"
        />
      )}
      <div className="editor-canvas">
        <TabsBar />
        <Scene3D />
        <div className="canvas-widget orient-cube-wrap">
          <OrientationCube />
        </div>
        <BottomToolbar />
        <ScaleIndicator />
        {notification.visible && (
          <div className="notification-toast">
            {notification.message}
          </div>
        )}
      </div>
    </div>
  );
}
